export const MSG_NO_PRICING='No pricing data available'
export const MSG_NO_ACCOUNTING_LOCATION='No accounting location'
export const MSG_PROMISE_FULFILLED='fulfilled'
export const MSG_PROMISE_REJECTED='rejected'
export const MSG_NO_INVENTORY='No inventory'
